/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommitImageResponse
 */
export interface CommitImageResponse {
    /**
     * 
     */
    objectKey?: string;
}

/**
 * Check if a given object implements the CommitImageResponse interface.
 */
export function instanceOfCommitImageResponse(value: object): value is CommitImageResponse {
    return true;
}

export function CommitImageResponseFromJSON(json: any): CommitImageResponse {
    return CommitImageResponseFromJSONTyped(json, false);
}

export function CommitImageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommitImageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'objectKey': json['objectKey'] == null ? undefined : json['objectKey'],
    };
}

export function CommitImageResponseToJSON(json: any): CommitImageResponse {
    return CommitImageResponseToJSONTyped(json, false);
}

export function CommitImageResponseToJSONTyped(value?: CommitImageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectKey': value['objectKey'],
    };
}

